import { createAction, props } from '@ngrx/store';


import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { RPERolActividades } from '../rpe-rol-actividades/rpe-rol-actividades.model';

// ADD
export const entityRPERolActividadesAddRequest = createAction(
  '[ENTITYRPEROLACTIVIDADES] Add Request',
  props<{ item: RPERolActividades }>()
);

export const entityRPERolActividadesAddFailure = createAction(
  '[ENTITYRPEROLACTIVIDADES] Add Failure',
  props<{ error: Error }>()
);

export const entityRPERolActividadesAddSuccess = createAction(
  '[ENTITYRPEROLACTIVIDADES] Add Success',
  props<{ item: RPERolActividades }>()
);
